module.exports = __webpack_public_path__ + "static/media/DotRed.367bd09b.svg";